import React, {useCallback, useRef, useState} from "react";
import Button from "../../../Button";
import classNames from "classnames";
import {GUIProps} from "./Types/GUIProps";
import debounce from "../../../../../utils/debounce";
import Icon from "../../../Icon";

const ActionButton = (props) => <div {...props}>
    {props.children}
</div>

export default (props: GUIProps) => {
    const b = useRef(null);
    const d = useRef(null);
    const [opened, setOpened] = useState(false);
    const toggle = useCallback(() => setOpened(!opened), []);
    const onBlurDebounce = useCallback(debounce(() => {
        setOpened(false);
    }, 250), []);
    const onBlur = useCallback((e) => {
        if (!(e.target === b.current || e.target === d.current)) {
            onBlurDebounce();
        }
    }, []);

    let actions = props.actions;
    if (actions instanceof Function) {
        actions = actions(props);
    }
    if (!actions) return null;
    return (
        <div className="p-actions-holder">
            <Button
                ref={b}
                color="default"
                onClick={toggle}
                onBlur={onBlur}
                tooltip="Műveletek"
                icon={{lib: "fa", name: "magic"}}
            >
                <span className="caret"/>
            </Button>
            <div ref={d} onClick={onBlur} className={classNames("p-actions", {opened})}>
                {actions?.map((Action, idx) => {
                    if (Action) {
                        return <Action
                            key={idx}
                            {...props}
                            opened={opened}
                            actionButton={ActionButton}
                        />;
                    }
                    return null;
                })}
            </div>
        </div>
    );
}